import { GetLanguagesRequest } from '../ServerApi/requests/GetLanguagesRequest';
import { ILanguage } from '../ServerApi/types/ILanguage';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { Messages } from '../../codegen/Localize';


export class Languages {

  public getAll(): ng.IPromise<ILanguage[]> {
    return WebHttpClient.sendRequest(new GetLanguagesRequest()).then(result => result.languages);
  }

  // a special value for the user language that indicates that we should use the server language
  public unspecifiedLanguage(): ILanguage {
    return {
      displayName: Messages.unspecified(),
      language: null,
      locale: null
    };
  }

}

export const LanguagesInstance = new Languages();